import {
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
} from '@/utils/cookie'
import { postAuthLogin } from '@/api/auth'
import { getMyself } from '@/api/profile'
import { getStorage, setStorage, removeStorage } from '@/utils/helpers'

const IS_VRIO_KEY = 'isVrio'

/**
 * @returns {{
 * me: Profile
 * }}
 */
const state = () => ({
  me: null,
  isVrio: getStorage(IS_VRIO_KEY) ? true : false,
})

const mutations = {
  setStateProps(state, payload) {
    state[payload.prop] = payload.value
  },
  setIsVrio(state) {
    setStorage(IS_VRIO_KEY, true)
    state.isVrio = true
  },
  clearIsVrio(state) {
    removeStorage(IS_VRIO_KEY)
    state.isVrio = false
  },
  setTokens(state, payload) {
    setToken(payload.access_token)
    setRefreshToken(payload.refresh_token)
  },
  clearTokens() {
    removeToken()
    removeRefreshToken()
  },
}

const getters = {
  isSales(state) {
    if (!state.me) return
    return state.me?.roles.includes('sales')
  },
}

const actions = {
  async auth({ commit }, payload) {
    try {
      commit('setStateProps', { prop: 'status', value: 'loading' })
      const resp = await postAuthLogin(payload)

      commit('setTokens', resp)
      commit('setStateProps', { prop: 'status', value: 'succeed' })
    } catch (error) {
      console.error(error)
      commit('setStateProps', { prop: 'status', value: 'error' })
      throw error
    }
  },
  async getMe({ commit, state }) {
    if (state.me) return

    try {
      const me = await getMyself()
      commit('setStateProps', { prop: 'me', value: me })
    } catch (error) {
      throw error
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
}
